import { useCallback, useEffect, useRef, useState } from 'react'

interface useCountdownConfig {
  callback?: () => void
}

export const useTimer = ({ callback }: useCountdownConfig) => {
  const [time, setTime] = useState<number>()
  const interval = useRef<NodeJS.Timeout | undefined>(undefined)

  const removeTimer = () => interval.current && clearTimeout(interval.current)

  useEffect(() => {
    if (time || time === 0) {
      // @ts-expect-error
      interval.current = setTimeout(() => {
        setTime(time - 1)
      }, 1000)

      if (time <= 0 && interval.current) {
        clearTimeout(interval.current)
        callback?.()
      }
    }

    return removeTimer
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [time])

  const setInitialTime = useCallback((initialTime: number) => setTime(initialTime), [])

  return {
    time,
    removeTimer,
    setInitialTime
  }
}
